require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-alumni-focused-events-boost-grads-careers-and-community.json") })
        }
      }, "path---blog-alumni-focused-events-boost-grads-careers-and-community");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-alumni-focused-events-boost-grads-careers-and-community!./.cache/json/blog-alumni-focused-events-boost-grads-careers-and-community.json
// module id = 586
// module chunks = 231608221292675